<nav>
  <ul class="header-menu__list">
    <ng-container
      [ngTemplateOutlet]="menu"
      [ngTemplateOutletContext]="{ menuItems: menuItems }"
    ></ng-container>
  </ul>
</nav>

<ng-template #menu let-menuItems="menuItems">
  <header-menu-item
    *ngFor="let menuItem of menuItems"
    [menuItem]="menuItem"
    [root]="true"
    [active]="isMenuItemActive(menuItem.id)"
    (toggleMenuItem)="onToggleMenuItem($event)"
  ></header-menu-item>
</ng-template>
